import { AccountDetailsOutlineIcon } from './AccountDetailsOutlineIcon';

/**
 * author: Simran
 * id B9137734-8DC1-41D1-9B34-CEDBB1742A39
 * name account-details-outline
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-details-outline.svg
 * tags
 * - Account / User 
 * - Settings 
 */
export const PersonDetailsOutlineIcon = AccountDetailsOutlineIcon;
export default PersonDetailsOutlineIcon